import { DefaultTheme, ThemeProps } from 'styled-components';
import { createHandler } from '@mews/std';
import { ButtonVariant } from '@optimus-web/local-tokens';

export const getColor = createHandler<ButtonVariant, ((props: ThemeProps<DefaultTheme>) => string) | string>(
    {
        primary: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
        secondary: (props) => props.theme.designTokens.TEXT_INTERACTIVE_DEFAULT,
        tertiary: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        ghost: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        destructive: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
    },
    (props) => props.theme.designTokens.TEXT_STATIC_SECONDARY
);

export const getBackgroundColor = createHandler<ButtonVariant, ((props: ThemeProps<DefaultTheme>) => string) | string>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_DEFAULT,
        secondary: 'transparent',
        tertiary: 'transparent',
        ghost: 'transparent',
        destructive: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_DANGER_DEFAULT,
    },
    'transparent'
);

export const getBorderColor = createHandler<ButtonVariant, ((props: ThemeProps<DefaultTheme>) => string) | string>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_DEFAULT,
        secondary: (props) => props.theme.designTokens.BORDER_INTERACTIVE_PRIMARY_DEFAULT,
        tertiary: (props) => props.theme.designTokens.BORDER_INTERACTIVE_SECONDARY_DEFAULT,
        ghost: 'transparent',
        destructive: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_DANGER_DEFAULT,
    },
    (props) => props.theme.designTokens.BORDER_INTERACTIVE_SECONDARY_DEFAULT
);

export const getHoverColor = createHandler<ButtonVariant, ((props: ThemeProps<DefaultTheme>) => string) | string>(
    {
        primary: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
        secondary: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
        tertiary: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        ghost: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        destructive: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
    },
    (props) => props.theme.designTokens.TEXT_STATIC_SECONDARY
);

export const getHoverBackgroundColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_HOVER,
        secondary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_HOVER,
        tertiary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER,
        ghost: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER,
        destructive: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_DANGER_HOVER,
    },
    (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER
);

export const getHoverBorderColor = createHandler<ButtonVariant, ((props: ThemeProps<DefaultTheme>) => string) | string>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_HOVER,
        secondary: (props) => props.theme.designTokens.BORDER_INTERACTIVE_PRIMARY_HOVER,
        tertiary: (props) => props.theme.designTokens.BORDER_INTERACTIVE_SECONDARY_HOVER,
        ghost: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER,
        destructive: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_DANGER_HOVER,
    },
    (props) => props.theme.designTokens.BORDER_INTERACTIVE_SECONDARY_HOVER
);

export const getDisabledColor = createHandler<ButtonVariant, ((props: ThemeProps<DefaultTheme>) => string) | string>(
    {
        primary: (props) => props.theme.designTokens.TEXT_DISABLED,
        secondary: (props) => props.theme.designTokens.TEXT_DISABLED,
        tertiary: (props) => props.theme.designTokens.TEXT_DISABLED,
        ghost: (props) => props.theme.designTokens.TEXT_DISABLED,
        destructive: (props) => props.theme.designTokens.TEXT_DISABLED,
    },
    (props) => props.theme.designTokens.TEXT_DISABLED
);

export const getDisabledBackgroundColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_DISABLED,
        secondary: 'transparent',
        tertiary: 'transparent',
        ghost: 'transparent',
        destructive: (props) => props.theme.designTokens.BACKGROUND_DISABLED,
    },
    'transparent'
);

export const getDisabledBorderColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_DISABLED,
        secondary: (props) => props.theme.designTokens.BORDER_DISABLED,
        tertiary: (props) => props.theme.designTokens.BORDER_DISABLED,
        ghost: 'transparent',
        destructive: (props) => props.theme.designTokens.BACKGROUND_DISABLED,
    },
    (props) => props.theme.designTokens.BORDER_DISABLED
);

export const getActiveColor = createHandler<ButtonVariant, ((props: ThemeProps<DefaultTheme>) => string) | string>(
    {
        primary: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
        secondary: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
        tertiary: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        ghost: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        destructive: (props) => props.theme.designTokens.BACKGROUND_DISABLED,
    },
    (props) => props.theme.designTokens.TEXT_STATIC_SECONDARY
);

export const getActiveBackgroundColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_ACTIVE,
        secondary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_ACTIVE,
        tertiary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE,
        ghost: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE,
        destructive: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_DANGER_ACTIVE,
    },
    (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE
);

export const getActiveBorderColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_ACTIVE,
        secondary: (props) => props.theme.designTokens.BORDER_INTERACTIVE_PRIMARY_ACTIVE,
        tertiary: (props) => props.theme.designTokens.BORDER_INTERACTIVE_SECONDARY_ACTIVE,
        ghost: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE,
        destructive: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_DANGER_ACTIVE,
    },
    (props) => props.theme.designTokens.BORDER_INTERACTIVE_SECONDARY_ACTIVE
);

export const getCounterColor = createHandler<ButtonVariant, ((props: ThemeProps<DefaultTheme>) => string) | string>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_DEFAULT,
        secondary: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
        tertiary: (props) => props.theme.designTokens.BACKGROUND_STATIC_FLAT,
        ghost: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
        destructive: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_DANGER_DEFAULT,
    },
    (props) => props.theme.designTokens.BACKGROUND_STATIC_FLAT
);

export const getCounterBackgroundColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
        secondary: (props) => props.theme.designTokens.TEXT_INTERACTIVE_DEFAULT,
        tertiary: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        ghost: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        destructive: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
    },
    (props) => props.theme.designTokens.TEXT_STATIC_SECONDARY
);

export const getCounterDisabledColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_DISABLED,
        secondary: (props) => props.theme.designTokens.TEXT_DISABLED,
        tertiary: (props) => props.theme.designTokens.TEXT_DISABLED,
        ghost: (props) => props.theme.designTokens.TEXT_DISABLED,
        destructive: (props) => props.theme.designTokens.BACKGROUND_DISABLED,
    },
    (props) => props.theme.designTokens.TEXT_DISABLED
);

export const getCounterDisabledBackgroundColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.TEXT_DISABLED,
        secondary: (props) => props.theme.designTokens.BACKGROUND_DISABLED,
        tertiary: (props) => props.theme.designTokens.BACKGROUND_DISABLED,
        ghost: (props) => props.theme.designTokens.BACKGROUND_DISABLED,
        destructive: (props) => props.theme.designTokens.TEXT_DISABLED,
    },
    (props) => props.theme.designTokens.BACKGROUND_DISABLED
);

export const getCounterActiveColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_ACTIVE,
        secondary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_ACTIVE,
        tertiary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE,
        ghost: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE,
        destructive: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_DANGER_ACTIVE,
    },
    (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE
);

export const getCounterActiveBackgroundColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
        secondary: (props) => props.theme.designTokens.BACKGROUND_STATIC_FLAT,
        tertiary: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        ghost: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        destructive: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
    },
    (props) => props.theme.designTokens.TEXT_STATIC_SECONDARY
);

export const getCounterHoverColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_HOVER,
        secondary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_PRIMARY_HOVER,
        tertiary: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER,
        ghost: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER,
        destructive: (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_DANGER_HOVER,
    },
    (props) => props.theme.designTokens.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER
);

export const getCounterHoverBackgroundColor = createHandler<
    ButtonVariant,
    ((props: ThemeProps<DefaultTheme>) => string) | string
>(
    {
        primary: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
        secondary: (props) => props.theme.designTokens.BACKGROUND_STATIC_FLAT,
        tertiary: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        ghost: (props) => props.theme.designTokens.TEXT_STATIC_PRIMARY,
        destructive: (props) => props.theme.designTokens.TEXT_STATIC_INVERSE,
    },
    (props) => props.theme.designTokens.TEXT_STATIC_SECONDARY
);
